import React from "react";
import { Drawer } from "@mui/material";
import "./drawer.scss";
import { isTMA } from "../constants";

function CommonDrawer({ anchor, open, onClose, className, ...props }) {
  return (
    <Drawer
      anchor={anchor}
      open={open}
      onClose={onClose}
      className={className}
      ModalProps={{
        disablePortal: !isTMA(),
      }}
      sx={{
        position: !isTMA() && "unset !important",
        ...props.sx,
      }}
    >
      {props.children}
    </Drawer>
  );
}

export default CommonDrawer;
